import {Component, Input, OnInit} from '@angular/core';
import {AssetRisk} from '../../../class/result/safeguard/asset-risk';
import {AbstractQuoteComponent} from '../abstract-quote-component';

@Component({
  selector: 'app-asset-risk-quote',
  templateUrl: './asset-risk-quote.component.html',
  styleUrls: ['./asset-risk-quote.component.css']
})
export class AssetRiskQuoteComponent extends AbstractQuoteComponent implements OnInit {

  @Input()
  assetRisk: AssetRisk;

  @Input()
  quakeType: number;

  @Input()
  fireType: number;

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
